module.exports = coreApis.installFeature;